import { Route, type RouteProps } from 'found';
import React from 'react';

import RedirectIfWalkIn from './redirect/RedirectIfWalkIn';

export default class WalkInRestrictedRoute extends Route {
	public render(routeProps?: RouteProps) {
		if (!routeProps) {
			return null;
		}

		return <RedirectIfWalkIn {...routeProps.props} />;
	}
}
